import { render, staticRenderFns } from "./ThreadStatusDropdown.vue?vue&type=template&id=47cc5a14&scoped=true"
import script from "./ThreadStatusDropdown.vue?vue&type=script&lang=js"
export * from "./ThreadStatusDropdown.vue?vue&type=script&lang=js"
import style0 from "./ThreadStatusDropdown.vue?vue&type=style&index=0&id=47cc5a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cc5a14",
  null
  
)

export default component.exports